<template>
    <div class="duty " :class="computer ? 'duty-pc' : ''">
        <header class="ant-layout-header">
            <div class="left">
                BOBO公式
            </div>
            <div class="right"></div>
        </header>
        <div class="duty-wrapper">
            <div class="duty-item" @click="handleSelectMode('1')">
                <div class="mode"> BOBO公式1</div>
                <div class="name">常规眼</div>
            </div>
            <div class="duty-item" @click="handleSelectMode('2')">
                <div class="mode"> BOBO公式2</div>
                <div class="name">屈光术后</div>
            </div>
        </div>

    </div>
</template>
<script setup>
import { isComputer } from "@/utils";
import { useRouter } from "vue-router";
const computer = isComputer();
const router = useRouter();

const handleSelectMode = (mode) => {
    router.push({
        path: "/calculate",
        query: {
            mode,
        },
    });
};

</script>
<style lang="less" scoped>
.ant-layout-header {
    padding: 0 10px;
    border-bottom: 1px solid #eee;
    margin-bottom: 1px;
    display: flex;
    justify-content: space-between;
    background: linear-gradient(135deg, #35b7ad 10%, #abdcff);
    color: #fff;
    font-size: 18px;
    font-weight: 600;
}

.duty-wrapper {
    padding: 0.1rem 0.2rem 0;
    display: flex;
    align-content: center;
    justify-content: center;
    padding-top: 120px;
    flex-wrap: nowrap;
    gap: 0.29rem;

    .duty-item {
        width: 3.1rem;
        height: 3.1rem;
        background: linear-gradient(326deg, #AFE6FF 0%, #37AEA5 100%);
        box-shadow: 0rem 0.02rem 0.05rem 0rem rgba(0, 0, 0, 0.2);
        border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
        text-align: center;
        margin-right: 0;
        padding-top: 0.7rem;
        box-sizing: border-box;

        .mode {
            font-size: 18px;
            color: #FFFFFF;
            font-weight: bold;
            letter-spacing: 1px;
            text-shadow: 0px 4px 10px #3BC0C4;
        }

        .name {
            font-weight: 500;
            font-size: 18px;
            color: #E8FBFF;
            letter-spacing: 1px;
        }
    }
}

.duty-pc {
    .ant-layout-header {
        height: 0.42rem;
        line-height: 0.42rem;
        font-size: 0.17rem;
        padding-left: 0.5rem;

        span {
            font-size: 0.09rem;
        }
    }

    .duty-wrapper {
        padding: 0.1rem 1.8rem 0;
        display: flex;
        align-content: center;
        justify-content: center;
        padding-top: 120px;
        flex-wrap: nowrap;
        gap: 0.29rem;

        .duty-item {
            width: 2.1rem;
            height: 2.1rem;
            background: linear-gradient(326deg, #AFE6FF 0%, #37AEA5 100%);
            box-shadow: 0rem 0.02rem 0.05rem 0rem rgba(0, 0, 0, 0.2);
            border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
            text-align: center;
            margin-right: 0;
            padding-top: 0.81rem;
            box-sizing: border-box;

            .mode {
                font-size: 0.24rem;
                color: #FFFFFF;
                letter-spacing: 1px;
                text-shadow: 0px 4px 10px #3BC0C4;
            }

            .name {
                font-weight: 500;
                font-size: 0.21rem;
                color: #E8FBFF;
                line-height: 58px;
                letter-spacing: 1px;
                margin-top: 20px;
            }
        }
    }

}
</style>